import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';
import getControllerForElement from '../helpers/getControllerForElement';

class HomeController extends Controller {
  connect() {
    // Disable this controller for pages other than home.
    if (window.location.pathname !== '/gratis-routeplanner' && window.location.pathname !== '/en/gratis-routeplanner') return;

    this.appURL = 'https://app.routelogic.io/freemium-schedule';
    this.appIsLoaded = false;
  }

  /* eslint-disable class-methods-use-this */
  onToggleClick({ currentTarget }) {
    // TODO: Iframe does no longer work on production. This is a temporary fix.
    // this.setIFrameSrc(currentTarget.dataset?.ref);
    window.location = `https://routelogic.nl?ref=${currentTarget.dataset?.ref}`;
  }

  setIFrameSrc(ref = null) {
    getControllerForElement(this.application, document.documentElement, 'attribution')
      .then((controller) => {
        const lastAttribution = controller.lastAttribution();

        let queryString = '';

        if (lastAttribution) {
          const firstAttributionCharacterization = controller.firstAttributionCharacterization();
          const lastAttributionCharacterization = controller.lastAttributionCharacterization();

          queryString += `?${controller.attributionObjectToQueryString({
            ...lastAttribution,
            first_attribution: firstAttributionCharacterization,
            last_attribution: lastAttributionCharacterization,
          })}`;
        }

        if (ref) {
          const glue = queryString.indexOf('?') >= 0 ? '&' : '?';

          queryString += `${glue}ref=${ref}`;
        }

        this.iframeTarget.src = `${this.appURL}${queryString}`;

        dataLayer.event('Freemium loaded', 'loaded', this.iframeTarget.src);

        this.setIFrameVisibilty();
      })
      .catch(() => {
        this.iframeTarget.src = this.appURL;

        this.setIFrameVisibilty();
      });
  }

  setIFrameVisibilty() {
    if (this.appIsLoaded) return;

    this.iframeTarget.addEventListener('load', () => {
      this.element.classList.add('app-is-loaded');
      this.iframeTarget.style.zIndex = 20;

      this.appIsLoaded = true;
      this.removeChatbot();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  removeChatbot() {
    const chatbot = document.querySelector('#futy-container');

    if (chatbot) {
      chatbot.remove();
    }
  }
}

HomeController.targets = [
  'iframe',
];

export default HomeController;
